import { StyleSheet } from "react-native";
import { Platform } from "react-native";
import { Dimensions } from "react-native";

let deviceWidth = Dimensions.get("window").width;

console.log(deviceWidth);

if (Platform.OS === "ios") {
  global.platform = "ios";
} else if (Platform.OS === "android") {
  // other thing for android
  global.platform = "android";
} else if (Platform.OS === "web") {
  // it's on web!
  global.platform = "web";
} else {
  // you probably won't end up here unless you support another platform!
  global.platform = "web";
}

export default StyleSheet.create({
  container: {
    flex: 1,
  },

  maxWdth80Percent: {
    maxWidth: "80%",
  },
  logo: {
    position: "absolute",
    width: 111,
    height: 39,
    marginRight: 1087,
    marginBottom: 290,
    top: 26,
    left: 32,
    resizeMode: "contain",
  },
  homeChatIconView: {
    justifyContent: "flex-start",
    alignItems: "flex-end",
  },

  sidePull: {
    position: "absolute",
    backgroundColor: "white",
    left: "-12%",
    top: "40%",
    width: 138,
    height: 92,
    borderRadius: 46,
    zIndex: 0,
    paddingTop: 35.5,
    paddingRight: 98,
    paddingBottom: 34.5,
    paddingLeft: 26,
  },

  botavatarview: {
    flexDirection: "row",
    width: 136,
    height: 79,
    marginTop: 290,
    paddingTop: 4,
    // paddingRight: 12,
    // marginLeft: 1087,
    paddingBottom: 5,
    paddingLeft: 23.1,
    borderRadius: 60,
    borderBottomRightRadius: 0,
    borderTopRightRadius: 0,
    backgroundColor: "#c83f49",
  },

  botavatar: {
    width: 70,
    height: 70,
    marginLeft: 19.9,
    resizeMode: "contain",
  },
  chevronLeft: {
    width: 11,
    height: 22,
    marginTop: 24.5,
    marginRight: 0,
    resizeMode: "contain",
  },
  botavatarHeader: {
    margin: 10,
    width: 46,
    height: 46,
    resizeMode: "contain",
  },

  chatcontainer: {
    position: "absolute",
    height: "85%",
    right: 10,
    top: 50,
    textAlign: "center",
    zIndex: 99,
  },

  chatcontainer_SMALL_MOBILE: {
    width: "100%",
    height: "100%",
    top: 0,
    right: 0,
  },
  chatcontainer_MEDIUM_MOBILE: {
    width: "100%",
    height: "100%",
    top: 0,
    right: 0,
  },
  chatcontainer_LARGE_MOBILE: {
    width: "100%",
    height: "100%",
    top: 0,
    right: 0,
  },
  chatcontainer_SMALL_TABLET: {
    width: "100%",
    height: "100%",
    top: 0,
    right: 0,
  },
  chatcontainer_MEDIUM_TABLET: {
    width: "50%",
  },
  chatcontainer_LARGE_TABLET: {
    width: "40%",
  },
  chatcontainer_LAPTOP: {
    width: "30%",
  },

  chatHeaderBox: {
    borderTopLeftRadius: Platform.OS == "web" ? 14 : 0,
    borderTopRightRadius: Platform.OS == "web" ? 14 : 0,
  },

  chattitle: {
    alignItems: "center",
    justifyContent: "space-between",
    flexDirection: "row",
    height: 76,
    // backgroundColor:'#d15a5e',
    // backgroundImage: "linear-gradient(to right, #d15a5e, #f19058)",
    shadowColor: "#000000",
    shadowOffset: { width: 0, height: 10 },
    shadowOpacity: 0.1,
    shadowRadius: 8,
    elevation: 10,
    paddingRight: 14,
    paddingBottom: 8,
    paddingTop: 5,
    paddingLeft: 20,
  },

  chatHeader: {
    height: 60,
    width: "100%",
    justifyContent: "space-between",
    flexDirection: "row",
  },

  titletext: {
    textAlign: "left",
    //paddingTop: 15,
    paddingLeft: 10,
    color: "white",
    fontFamily: "RoundedMplus1cBold",
    fontSize: 20,
    fontWeight: "bold",
    alignItems: "center",
  },

  scrollview: {
    //height:'100%',
    height: 0,
    bottom: 0,
  },

  chatfooter: {
    alignSelf: "flex-end",
    flexDirection: "row",
    position: "relative",
    width: "100%",
    bottom: 10,
    marginTop: 20,
    //borderTopWidth: 0.5,
    //borderColor: "#a1a1a1",
    //opacity: 0.5,
  },
  txtInfoBox: {
    padding: 5,
    textAlign: "left",
    color: "black",

    fontSize: 16,
  },
  infoBox: {
    flex: 1,
    justifyContent: "flex-start",
    alignItems: "flex-start",
    //width: 400,
    flexDirection: "row",
    alignSelf: "center",
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 1,
    },
    shadowOpacity: 0.22,
    shadowRadius: 2.22,

    elevation: 3,
    borderRadius: 8,
    backgroundColor: "#f1f0f0",
    // borderColor: 'black',
    // borderWidth: 1,
    // borderStyle: 'solid',
    //marginVertical: 10,
    margin: 10,
    marginLeft: global.platform == "web" ? 10 : 40,
    marginRight: global.platform == "web" ? 10 : 40,
    padding: 10,
  },
  txtInfoBoxss: {
    padding: 5,
    textAlign: "left",
    color: "black",
    fontSize: 14,
  },

  timer: {
    marginVertical: 10,
    alignSelf: "flex-end",
    alignContent: "center",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "row",
    alignSelf: "center",
    // shadowColor: "#000",
    // shadowOffset: {
    //   width: 0,
    //   height: 1,
    // },
    // shadowOpacity: 0.22,
    // shadowRadius: 2.22,
    // elevation: 3,
    backgroundColor: "#3fb7f5",
    borderColor: "#3fb7f5",
    borderWidth: 3,
    borderStyle: "solid",
    borderRadius: 200,
    width: 70,
    minHeight: 70,
    marginLeft: 10,
  },

  chatinput: {
    width: 338,
    height: 56,
    marginLeft: 5,
    marginRight: 19.3,
    marginTop: 18,
    marginLeft: 18,
    paddingLeft: 25,
    paddingTop: 16,
    paddingRight: 40,
    lineHeight: 22,
    paddingBottom: 18,
    borderRadius: 32,
    backgroundColor: "#eceaea",
    flex: 1,
    overflow: "hidden",
    fontSize: deviceWidth < 321 ? 12 : 15,
    fontStyle: "normal",
    textAlign: "left",
    justifyContent: "center",
    color: "#000000",
    fontFamily: "SFProText",
    // placeholderTextColor: "#a1a1a1",
  },

  chatvoiceinput: {
    flex: 1,
    position: "absolute",
    alignSelf: "center",
    width: 16,
    height: 24,
    right: 30,
    bottom: 18,
    resizeMode: "contain",
    borderRadius: 50,
  },

  chatvoiceinputrecording: {
    flex: 1,
    position: "absolute",
    alignSelf: "center",
    width: 16,
    height: 24,
    right: 30,
    bottom: 18,
    resizeMode: "contain",
    borderRadius: 50,
    tintColor: "#ff0000",
  },

  chatsubmit: {
    width: 28.5,
    height: 22,
    flex: 3,
    padding: 0,
    right: 5,
    bottom: 0,
    resizeMode: "contain",
    marginRight: 22.3,
    // marginBottom: 17.3,
    marginBottom: -10,
  },

  onlineImage: {
    width: 20,
    height: 20,
  },

  chatbubbleleft: {
    padding: 10,
    textAlign: "left",
    borderRadius: 10,
    left: 0,
    position: "relative",
    bottom: 0,
    minWidth: "40%",
    flexDirection: "row",
    // marginBottom: 8,
    // marginLeft: 2,
    // marginRight: 20,
    // paddingTop: 25,
    // paddingRight: 27.1,
    // paddingBottom: 25,
    // paddingLeft: 41.7,
    // backgroundColor: "#f5f5f5",
  },
  chatbubbleleftonVideoPlayer: {
    padding: 10,
    textAlign: "left",
    borderRadius: 10,
    left: 0,
    position: "relative",
    bottom: 0,
    minWidth: "40%",
    flexDirection: "row",
    marginLeft: Platform.OS != "web" ? 25 : 0,
  },

  chatmessageavatar: {
    width: 50,
    height: 50,
    resizeMode: "contain",
  },
  customeravatar: {
    width: 40,
    height: 40,
    resizeMode: "contain",
  },

  chatbubblelefttext: {
    fontSize: 15,
    textAlign: "left",
    fontWeight: "300",
    color: "#273a4e",
    fontStyle: "normal",
    lineHeight: 22,
    // minWidth: "10%",
    // overflow: "hidden",
    padding: 10,
    fontFamily: "SFProText",
    zIndex: -999,
  },

  chatTime: {
    fontSize: Platform.OS == "web" ? 10 : 11,
    fontWeight: "300",
    color: "#b3b3b3",
    fontFamily: "SFProText",
    textAlign: "center",
  },

  marginBottom20: {
    marginBottom: 20,
  },

  chatTimeRight: {
    marginRight: 10,
    textAlign: "right",
  },

  chatTimeLeft: {
    marginLeft: 10,
    textAlign: "left",
  },

  chatMessageBox: {
    flex: 1,
    backgroundColor: "white",
    borderBottomLeftRadius: 15,
    borderBottomRightRadius: 15,
  },
  agentonTypingView: {
    margin: 5,
    padding: 10,
    backgroundColor: "#f5f5f5",
    borderRadius: 12,
    borderBottomLeftRadius: 0,
    minWidth: 100,
    minHeight: 40,
    // minWidth: "10%",
    // minHeight: "70%",
    overflow: "hidden",
    marginLeft: 8,
    marginRight: 10,
    justifyContent: "center",
    alignItems: "center",
  },
  chatbubblelefttextAfterConnect: {
    margin: 5,
    marginRight: 100,
    left: 0,
    padding: 10,
    paddingRight: 20,
    backgroundColor: "#f5f5f5",
    borderRadius: 10,
    borderBottomLeftRadius: 0,

    fontSize: 16,
    textAlign: "left",
    fontWeight: "300",
    color: "#000000",
    minWidth: "2%",
    overflow: "hidden",
  },

  chatbubbleright: {
    padding: 10,
    textAlign: "left",
    left: 0,
    position: "relative",
    bottom: 0,
    // marginLeft: "20%",
    flexDirection: "row-reverse",
    alignItems: "flex-end",
    minWidth: "40%",
  },

  padding10: {
    padding: 10,
  },

  chatbubblerighttext: {
    margin: 5,
    // marginBottom: 0,
    left: 0,
    borderRadius: 14,
    borderBottomRightRadius: 0,
    fontSize: 15,
    // lineHeight: 22,
    fontStyle: "normal",
    fontWeight: "300",
    color: "white",
    minWidth: "10%",
    overflow: "hidden",
    zIndex: 5,
    color: "white",
    fontFamily: "SFProText",
  },

  //header css
  DesktopWelcomeBox: {
    borderRadius: 100,
    padding: 20,
    opacity: 0.6,
    backgroundColor: "white",
    width: 740,

    // marginTop: 500,
    bottom: 15,
    position: "absolute",
    // alignSelf: 'flex-end',
    marginLeft: 20,
  },

  disabledOpacity: {
    opacity: 0.5,
  },

  txtDesktopWelcomeBox: {
    color: "black",

    fontSize: 15,
  },
  wnsLogo: {
    position: "absolute",
    width: 93,
    height: 32,
    marginLeft: 43,
    resizeMode: "contain",
  },
  headerView: {
    height: 73,
    backgroundColor: "#ffffff",
    shadowColor: "#000000",
    shadowOffset: { width: 0, height: 10 },
    shadowOpacity: 0.1,
    shadowRadius: 8,
    elevation: 10,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },

  textCenter2: {
    textAlign: "center",
    color: "#000000",
  },
  textCenter1: {
    textAlign: "center",
    color: "#ffffff",
  },
  chatOuterView: {
    flexDirection: "row",
    margin: 10,
    alignItems: "flex-end",
  },
  operatorChatView: {
    flexDirection: "row",
    margin: 2,
  },
  chatOuterView1: {
    flexDirection: "row",
    margin: 2,
    padding: 10,
  },
  btnText: {
    color: "white",
  },

  reload: {
    marginRight: 18,
    justifyContent: "center",
    alignItems: "center",
  },
  reloadImage: {
    width: 18,
    height: 18,
    resizeMode: "contain",
  },

  reloadImageOrange: {
    width: 15,
    height: 12,
    resizeMode: "contain",
  },
  closeImage: {
    width: 18,
    height: 18,
    resizeMode: "contain",
  },
  closeIconView: {
    marginLeft: 18,
    marginRight: 18,
    justifyContent: "center",
    alignItems: "center",
  },

  typingGifView: {
    margin: 5,
    marginRight: 50,
    padding: 10,
    backgroundColor: "#f1f0f0f5",
    borderRadius: 10,
    minWidth: "10%",
    overflow: "hidden",
    justifyContent: "center",
    alignItems: "center",
  },
  typingImage: {
    width: 20,
    height: 20,
    position: "absolute",
  },

  agentConnect: {
    alignContent: "center",
    justifyContent: "center",
    textAlign: "center",
    width: "100%",
  },

  flexRow: {
    flexDirection: "row",
    alignItems: "center",
  },
  margin0: {
    margin: 0,
  },
});
